import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { RequireAuth } from '../auth';
import {
  APTesting,
  BatchRate,
  GeoMileage,
  Home,
  InvoiceAudit,
  NotFound,
  ParcelRate,
  PullAndSend,
  PullData,
  RateCompare,
  Results,
  RuntimeHub,
  SigninCallback,
  UploadAnalyze,
} from '../pages';
import { ROUTES } from './constants';

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={ROUTES.SIGNIN_CALLBACK.path}
          element={<SigninCallback />}
        />
        {/* AUTH ROUTES */}
        <Route element={<RequireAuth />}>
          <Route path={ROUTES.HOME.path} element={<Home />} />
          <Route
            path={ROUTES.BATCH_RATE.path}
            element={<BatchRate />}
          />
          <Route
            path={ROUTES.AP_TESTING.path}
            element={<APTesting />}
          />
          <Route
            path={ROUTES.RATE_COMPARE.path}
            element={<RateCompare />}
          />
          <Route
            path={ROUTES.PARCEL_RATE.path}
            element={<ParcelRate />}
          />
          <Route
            path={ROUTES.GEO_MILEAGE.path}
            element={<GeoMileage />}
          />
          <Route
            path={ROUTES.INVOICE_AUDIT.path}
            element={<InvoiceAudit />}
          />
          <Route
            path={ROUTES.UPLOAD_ANALYZE.path}
            element={<UploadAnalyze />}
          />
          <Route path={ROUTES.PULL_DATA.path} element={<PullData />} />
          <Route
            path={ROUTES.PULL_AND_SEND.path}
            element={<PullAndSend />}
          />
          <Route path={ROUTES.RESULTS.path} element={<Results />} />
          <Route path={ROUTES.RUNTIME_HUB.path} element={<RuntimeHub />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
